import {
  isPostPaymentAbstractEnabled,
  POST_PAYMENT_ABSTRACT_FORM_STEP,
} from "../registration/registrationModules";

export const getExistingPaperCanResume = (paperStatus) => {
  const normalizedStatus = (paperStatus || "").trim().toUpperCase();
  return (
    normalizedStatus === "DRAFT" ||
    normalizedStatus === "MINOR_REVISION" ||
    normalizedStatus === "MAJOR_REVISION" ||
    normalizedStatus === "REVISION_REQUESTED"
  );
};

export const getExistingRegistrationNavigationDecision = ({
  isPaid,
  hasPaperSubmitted,
  loadedPaperStatus,
  isApprovalMandateEnabled,
  isPendingPaperApprovalStatus,
  abstractStepNumber,
}) => {
  const isPaperPendingApproval =
    isApprovalMandateEnabled &&
    hasPaperSubmitted &&
    (isPendingPaperApprovalStatus(loadedPaperStatus) || !loadedPaperStatus);

  if (isPaperPendingApproval) {
    return {
      type: "paperPendingApproval",
      step: 3,
      ready: false,
      showPaperSubmissionSummary: true,
      resumePostPaymentAbstract: false,
    };
  }

  const canResumeLoadedPaper = getExistingPaperCanResume(loadedPaperStatus);
  const shouldOpenPostPaymentPaperStep =
    isPostPaymentAbstractEnabled(abstractStepNumber) &&
    ((isPaid && !hasPaperSubmitted) || canResumeLoadedPaper);

  if (shouldOpenPostPaymentPaperStep) {
    return {
      type: "postPaymentPaper",
      step: POST_PAYMENT_ABSTRACT_FORM_STEP,
      ready: false,
      showPaperSubmissionSummary: false,
      resumePostPaymentAbstract: canResumeLoadedPaper,
    };
  }

  return {
    type: "deferToRegistrationNavigation",
    step: null,
    ready: true,
    showPaperSubmissionSummary: false,
    resumePostPaymentAbstract: canResumeLoadedPaper,
  };
};
